import { Notifications, WidgetTemplate } from '@types';
import memoize from 'fast-memoize';
import { dateMonthFormat, dateOnlyMonthFormat } from '@utils/dateFormat';
import { CodingConstants, UIConstants } from '@constants';
import { cloneDeep } from 'lodash';
export const filterCards = memoize((loanNumber: string, widgetApiResponse: any) => {
    const cards = widgetApiResponse?.cards
        ?.filter((card: { initParam: any }) => card.initParam)
        .map((elem: { initParam: any[]; id: string }) => elem?.initParam?.find(el => el.value == loanNumber) && elem.id);

    return cards;
});
export const filterAlertsifEscrowScheduledExsists = memoize(
    (widgets: WidgetTemplate, alerts: Notifications[], loanNumber?: any, templateIcon = 'schedule') => {
        if (widgets === undefined) {
            return alerts;
        } else {
            const escrowScheduledWidget =
                widgets?.initParam && widgets?.initParam.length > 0 && widgets?.initParam.find(ele => ele.loanNumber === loanNumber);
            if (escrowScheduledWidget) {
                const filteredAlerts: Notifications[] = [];
                const escrowSubject =
                    escrowScheduledWidget?.previousAnalysisDate != null
                        ? UIConstants.escrowSeeMoreText + dateOnlyMonthFormat(escrowScheduledWidget.previousAnalysisDate) + '.'
                        : '';
                const escrowContent =
                    escrowScheduledWidget?.currentAnalysisDate != null
                        ? UIConstants.escrowSeeMoreTextEffective + dateMonthFormat(escrowScheduledWidget.currentAnalysisDate) + '.'
                        : '';
                filteredAlerts.push({
                    notificationId: widgets?.id,
                    subject: escrowSubject,
                    content: escrowContent,
                    link: UIConstants.escrowLearnMoreLink,
                    template: {
                        templateIcon
                    },
                    loanType: ''
                });
                alerts != undefined && alerts.length > 0 && filteredAlerts.push(alerts[0]);
                return filteredAlerts;
            } else {
                return alerts;
            }
        }
    }
);

export const getSortedOfferCardsByTeaserOffer = (allCards: WidgetTemplate[], loanNumber: string): WidgetTemplate[] => {
    const { offerGroup, teaserOfferGroup } = CodingConstants;
    let cards = cloneDeep(allCards);
    const teaserOfferCards = cards?.filter(item => item.group === teaserOfferGroup);
    if (!teaserOfferCards.length) {
        const bundleOffers = cards?.filter(item => item.group === offerGroup);
        if (bundleOffers && bundleOffers.length) {
            const originalOffersObject = bundleOffers[0];

            if (originalOffersObject?.initParam && originalOffersObject.initParam.length > 0) {
                const initParam = originalOffersObject.initParam.find(ele => ele.loanNumber === loanNumber);

                if (initParam && initParam.offers) {
                    const { offers } = initParam;
                    // Find all offers with teaserOfferFlg="Yes"
                    const teaserOffers = offers.filter((offer: any) => offer.teaserOfferFlg === 'Yes');

                    // If there are matching offers, find the one with the lowest priorityNo i.e., first element because it is already sorted from API
                    if (teaserOffers.length > 0) {
                        const highestPriorityOffer = teaserOffers[0];
                        // Remove the highest priorityNo offer from the original 'offers' object
                        originalOffersObject.initParam[0].offers = offers.filter(
                            (offer: any) => offer.priorityNo !== highestPriorityOffer.priorityNo
                        );
                        // Create a new 'offers' object with the highest priorityNo offer
                        const newOffersObject = {
                            ...originalOffersObject,
                            group: teaserOfferGroup,
                            rank: '0',
                            initParam: [
                                {
                                    ...initParam,
                                    offers: [highestPriorityOffer]
                                }
                            ]
                        };
                        // Add the new 'offers' object at the beginning
                        cards = [newOffersObject, ...cards];
                    }
                }
            }
        }
    }
    return cards;
};

export const updateNbpCardRefactorLoc = (allNBPcards: any, loanNumber: any, id: string) => {
    const nbpCardsLoc = { ...allNBPcards };
    const nbpCardsLocSelectedLoan = [...nbpCardsLoc[loanNumber]];

    const popups = nbpCardsLocSelectedLoan.map((item: any) => {
        if (item.product === id) return { ...item, status: 'completed' };
        return item;
    });
    nbpCardsLoc[loanNumber] = popups;
    return nbpCardsLoc;
};
